/**
 * Play V2 background treatments — Play-tab local only.
 * Shared header chrome, shared overlay tokens, and other tabs stay untouched.
 */

import { parseV2BackgroundAssetFromSrc } from '@/lib/home/homeV2Background'

/**
 * Localized upper-left vignette for play_morning only.
 * Softens the sunburst behind the shared white logo without a header bar
 * or global photo-overlay change. Lives on the background layer (z-0).
 */
export const playMorningLogoZoneVignette =
  'radial-gradient(ellipse 70% 55% at 8% 6%, rgba(12, 10, 12, 0.55) 0%, rgba(12, 10, 12, 0.22) 42%, transparent 72%)' as const

/** Returns the Play-morning logo-zone vignette when `src` is play_morning; else null. */
export function resolvePlayMorningLogoZoneVignette(src: string): string | null {
  const parsed = parseV2BackgroundAssetFromSrc(src)
  if (!parsed) return null
  if (parsed.section !== 'play' || parsed.daypart !== 'morning') return null
  return playMorningLogoZoneVignette
}
